__turbopack_context__.v({
  "caption": "connected-answer-module__VXfsGa__caption",
  "card": "connected-answer-module__VXfsGa__card",
  "cardContent": "connected-answer-module__VXfsGa__cardContent",
  "controls": "connected-answer-module__VXfsGa__controls",
  "exhibit": "connected-answer-module__VXfsGa__exhibit",
  "play": "connected-answer-module__VXfsGa__play",
  "shellPrompt": "connected-answer-module__VXfsGa__shellPrompt",
  "stack": "connected-answer-module__VXfsGa__stack",
  "terminal": "connected-answer-module__VXfsGa__terminal",
  "terminalDots": "connected-answer-module__VXfsGa__terminalDots",
  "terminalLabel": "connected-answer-module__VXfsGa__terminalLabel",
  "terminalNote": "connected-answer-module__VXfsGa__terminalNote",
  "terminalRecords": "connected-answer-module__VXfsGa__terminalRecords",
});
